import {SEARCH_SELECT_BLOGS_TYPE} from "../../constants/commons";
import {FocusedSearchSelect} from "./FocusedSelect";


export const BlogsSearchSelect = ({value, label, placeholder, onChange, extData}) => {

  return (
    <FocusedSearchSelect placeholder={placeholder ?? "Search for blogs"} value={value} extData={extData}
                         label={label ?? "Blogs"} type={SEARCH_SELECT_BLOGS_TYPE}
                         onChange={onChange}/>
  );
};




